var SupportMode = {
  XHR: 1,
  XDR: 2,
  BCN: 4,
  NONE: 3
};

var support = SupportMode.NONE;
if (window.XMLHttpRequest) {
  var request = new XMLHttpRequest();
  if('withCredentials' in request) {
    support = SupportMode.XHR;
  } else if (window.XDomainRequest) {
    support = SupportMode.XDR;
  }
  request = null;
}

module.exports.hasSupport = function() {
  return support !== SupportMode.NONE;
};

module.exports.send = function(method, url, opt_data) {
  var mode = method === 'beacon_post' ? SupportMode.BCN : support;

  switch (mode) {
    case SupportMode.XHR:
      var request = new XMLHttpRequest();
      request.open(method, url, true);
      request.withCredentials = true;
      request.send(opt_data);
      break;
    case SupportMode.XDR:
      var xdr = new XDomainRequest();
      xdr.open(method, url);
      xdr.send(opt_data);
      break;
    case SupportMode.BCN:
      var enqueued = navigator.sendBeacon(url, opt_data);
      if (!enqueued) {
        module.exports.send('post', url, opt_data);
      }
      break;
  }
};



//////////////////
// WEBPACK FOOTER
// ./lib/cors.js
// module id = 6
// module chunks = 1 3